module.exports = __webpack_public_path__ + "media/game-video.139558bf.mp4";